export default __webpack_public_path__ + "static/media/factura4.3a9befc6.pdf";